import { Druckvorlage } from "@/models/DruckvorlageModels";

export type State = {
  druckvorlagen: Array<Druckvorlage>
}

export const state: State = {
  druckvorlagen:  localStorage.getItem("druckvorlagen") != null && localStorage.getItem("druckvorlagen") !== undefined ? JSON.parse(localStorage.druckvorlagen) : new Array<Druckvorlage>(),
}
